module.exports = __webpack_public_path__ + "static/media/UK_Flag.6aebdf4d.svg";